import { apiSlice } from "./apiSlice";

// export const Activecolorlist = createAsyncThunk('/activecolorlist', async () => {
//   const response = await ApiHelperFunction({
//     urlPath: 'productColour/active/colour',
//     method: 'GET',
//   });
//   return response;
// });

export const colorSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    colorlist: builder.mutation({
      query: (data) => ({
        url: 'productColour?' + data,
        method: 'GET',
        credentials: "include",
      }),

    }),
    Create_Update_color: builder.mutation({
      query: (data) => ({
        method: "POST",
        body: data,
        url: 'productColour',
        credentials: "include",
      })
    }),
    GetColorData: builder.mutation({
      query: (id) => ({
        method: "GET",
        url: 'productColour/' + id,
        credentials: "include",
      })
    }),

    ColorDelete: builder.mutation({
      query: (id) => ({
        url: 'productColour',
        method: "DELETE",
        body: id,
        credentials: "include",
      }),

    }),
    getActiveColor: builder.mutation({
      query: () => ({
        url: '/productColour/active/colour',
        method: "GET",
        credentials: "include",
      }),

    }),



  }),
});

export const {
  useColorlistMutation,
  useCreate_Update_colorMutation,
  useGetColorDataMutation,
  useColorDeleteMutation,
  useGetActiveColorMutation
} = colorSlice;
